import React, { useState, useEffect } from 'react';
import localization from 'assets/localization/localization';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import Regex from 'services/utils/regex/Regex';

const createTicketInputs = {
  toName: '',
  userId: '',
  subject: '',
  summary: '',
  document: '',
};

const CreateTicketForm = ({
  createTicketSubmit,
  documentUploadUrl,
  documentUrlData,
  getSearchUser,
  searchUser = [],
}) => {
  const [createTicketData, setCreateTicketData] = useState(createTicketInputs);
  const [className, setClassName] = useState('empty');
  const [suggestionList, setSuggestionList] = useState(false);

  const onBlur = () => {
    if (createTicketData.summary.split('').length === 0) {
      setClassName('empty');
    } else {
      setClassName('');
    }
  };
  const onFocus = () => {
    if (createTicketData.summary.split('').length === 0) {
      setClassName('empty');
    } else {
      setClassName('');
    }
  };

  const createTicketHandle = () => {
    let isValue = true;
    for (const key in createTicketData) {
      if (key !== 'document') {
        if (!createTicketData[key]) {
          isValue = false;
        }
      }
    }
    isValue ? createTicketSubmit(createTicketData) : createTicketSubmit(null);
  };

  const onChangeHandle = async (val) => {
    if (val.length > 2) {
      const res = await getSearchUser(val);
      res && setSuggestionList(true);
    } else setSuggestionList(false);
  };

  const setToName = (val) => {
    setCreateTicketData({
      ...createTicketData,
      toName: val.name,
      userId: val.id,
    });
    setSuggestionList(false);
  };

  useEffect(() => {
    createTicketHandle();
  }, [createTicketData]);

  return (
    <form className="create-ticket-form">
      <ConstantInput
        fullWidth
        label={localization.toName}
        value={createTicketData.toName}
        type="text"
        errorMsg={localization.requiredName}
        required
        isStarRequired={true}
        handleChange={(val) => onChangeHandle(val)}
      />
      {searchUser && suggestionList && (
        <div className="form-group full-width">
          <ul className="suggestion-list scrollbar-styling">
            {searchUser.length > 0 ? (
              searchUser.map((user, ind) => (
                <li key={ind} onClick={() => setToName(user)}>
                  {user.name}
                </li>
              ))
            ) : (
              <li>{localization.noRecord}</li>
            )}
          </ul>
        </div>
      )}
      <ConstantInput
        fullWidth
        label={localization.enterSubject}
        value={createTicketData.subject}
        regex={Regex.text.test(createTicketData.subject)}
        type="text"
        errorMsg={localization.requiredSubject}
        required
        isStarRequired={true}
        maxLength={150}
        handleChange={(val) =>
          setCreateTicketData({ ...createTicketData, subject: val })
        }
      />

      <TextAreaInput
        type="text"
        rows={4}
        label={localization.summary}
        className={`${className} inline-css scrollbar-styling`}
        onFocus={onFocus}
        onBlur={onBlur}
        inputValue={createTicketData?.summary}
        regex={Regex.text.test(createTicketData.summary)}
        errorMsg={localization.requiredSummary}
        required
        isStarRequired={true}
        handleChange={(e) => {
          setCreateTicketData({
            ...createTicketData,
            summary: e.target.value,
          });
          e.target.value !== '' && setClassName('');
        }}
      />

      <div className="form-group form-btn">
        <FileUpload
          id="addReplyAttachment"
          multiple="multiple"
          accept=".pdf,.png,.jpg,.jpeg,.doc"
          documentUploadUrl={documentUploadUrl}
          documentUrlData={documentUrlData}
          onChange={(val) =>
            setCreateTicketData({
              ...createTicketData,
              document: val,
            })
          }
        >
          <span className="btn btn-transparent">
            {localization.uploadMultiAttachment}
          </span>
        </FileUpload>
      </div>
    </form>
  );
};

export default CreateTicketForm;
